export default __webpack_public_path__ + "static/media/nl-google.045b88dd.webp";